import { Snackbar } from "@material-ui/core";
import MuiAlert from '@material-ui/lab/Alert';
import CloseIcon from '@material-ui/icons/Close';
import React from "react";

export default function AlertComponent({open,message,handleClose,severity}:{open:boolean, message:string, handleClose:Function,severity:'error'| 'info'| 'success'| 'warning'}) {

return (
    <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={open}
        autoHideDuration={6000}
        onClose={e=>handleClose()}
    >
      <MuiAlert elevation={6} variant="filled" onClose={e=>handleClose()} severity={severity}>
        {message}
      </MuiAlert>
    </Snackbar>
);
}